import {
  AffectedCompanyImportingInaccessibleMdrContacts,
  ResponseAffectedCompaniesImportingInaccessibleMdrContacts,
} from '../types/common/mdrTypes';
import { ConsoleRequest, CreateRequestPayload, DataProviderEntity, DataProviderType } from './request';

/**
 * Fetches the affected companies importing inaccessible MDR contacts.
 * This is done by sending a request to the backend with the moved entity IDs and the destination target ID.
 *
 * @param entityIds The IDs of the moved entities
 * @param destinationTargetId The ID/Hash of the destination target (new parent). Hash is possible only for companies
 */
export async function fetchAffectedCompaniesImportingInaccessibleMdrContacts(
  entityIds: string[],
  destinationTargetId: string
): Promise<ResponseAffectedCompaniesImportingInaccessibleMdrContacts> {
  const payload: CreateRequestPayload = {
    dataProviderType: DataProviderType.CORE,
    dataProviderEntity: DataProviderEntity.MODEL,
    endpoint: 'MdrCompany',
    method: 'getAffectedCompaniesImportingInaccessibleMdrContacts',
    payload: {
      movedEntityIds: entityIds,
      destinationTargetId: destinationTargetId,
    },
  };

  return await ConsoleRequest.createRequest<ResponseAffectedCompaniesImportingInaccessibleMdrContacts>(payload);
}

/**
 * Builds a CSV string for the affected companies importing inaccessible MDR contacts.
 *
 * @param affectedCompanies An array of affected companies with their details.
 */
export function buildCsvForInaccessibleMdrContacts(
  affectedCompanies: AffectedCompanyImportingInaccessibleMdrContacts[]
): string {
  let csvContent = 'data:text/csv;charset=utf-8,';

  csvContent += '"Company ID","Company Name","Partner Name","MDR Contact Email"\n';

  for (const company of affectedCompanies) {
    csvContent += '"' + company.id + '",';
    csvContent += '"' + company.name + '",';
    csvContent += '"' + company.partnerName + '",';
    csvContent += '"' + company.mdrContactEmail + '"\n';
  }

  return encodeURI(csvContent);
}
